import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { AppLauncher } from '@capacitor/app-launcher';
import { MatDialog } from '@angular/material/dialog';
import {ExternalExitDialogComponent} from "../components/external-exit-dialog/external-exit-dialog.component";

@Injectable({ providedIn: 'root' })
export class ExternalLinkService {
  constructor(private readonly dialog: MatDialog) {}

  async openLinkBasedOnConsent(url: string): Promise<void> {
    const { value } = await Preferences.get({ key: 'externalLinkConsent' });

    if (value === 'false') {
      const dialogRef = this.dialog.open(ExternalExitDialogComponent, {
        disableClose: true
      });

      const result = await dialogRef.afterClosed().toPromise();

      if (result) {
        await AppLauncher.openUrl({ url });
      }

      return;
    }

    await AppLauncher.openUrl({ url });
  }
}
